import { IconButton, Menu, MenuItem, Button,withStyles } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import FunctionsContext from './FunctionsContext';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

const ProcedureManualCheckedButton = styled.img`
height:42px;
width:40px;
`;

const StyledButton = withStyles({
    root: {
     minWidth:20
    }

  })(Button);

const FunctionsForMenu = ({}) => {

 
    const context = React.useContext(FunctionsContext)

    const [anchorEl, setAnchorEl] = React.useState(null);

    return (
        <>
        <StyledButton
        variant="contained" 
        aria-controls="simple-menu"
        aria-haspopup="true" 
        color='primary' 
        onClick={event => {
            setAnchorEl(event.currentTarget) 
         }}>
            Edit {<KeyboardArrowDown/>}
        </StyledButton>
        <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() =>  setAnchorEl(null)}                           
        >
            <MenuItem
                onClick={()=> {
                    setAnchorEl(null);
                    context.displayWorkflowDialog();
            }}
            >
                Workflow Steps
            </MenuItem>
            <MenuItem
                // disabled={action.activeOneTimeDeviation}
                onClick={()=> {
                    setAnchorEl(null);
                    context.displayFunctionNotificationDialog();
                }}
            >
                Email Notifications
            </MenuItem>
            {/* } */}
        </Menu>
        </>
    );
}

export default FunctionsForMenu;